import { ActionType } from "../actions/actionTypes";

type CodeRefState = {
  [key: string]: CodeRef[];
};

const INITIAL_STATE = {};

export default (
  state: CodeRefState = INITIAL_STATE,
  action: ActionType
): CodeRefState => {
  switch (action.type) {
    case "FETCH_CODE_REFS_SUCCESS": {
      return { ...state, ...action.payload };
    }
    default:
      return state;
  }
};
